import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldTree } from '@angular/forms/signals';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'lib-field-errors',
  imports: [TranslatePipe],
  templateUrl: './field-errors.html',
  styles: `
    .error-list {
      list-style-type: disclosure-closed;
      font-size: 0.8rem;
      color: oklch(57.7% 0.245 27.325);
      margin: 0;
      padding-inline-start: 2rem;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldErrors<T> {
  public readonly fieldRef = input.required<FieldTree<T>>();
}
